import React, {Dispatch, SetStateAction, InputHTMLAttributes, useId} from "react"
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch"

interface ToggleSettingsProps extends InputHTMLAttributes<HTMLInputElement> {
	name: string
	title: string
	description: string
	onChange: Dispatch<SetStateAction<any>>
}

export default function ToggleSettings({name, title, description, onChange, ...inputProps}: ToggleSettingsProps) {
	const checkboxId = `${name}-${useId()}`
	return (
		<div className="toggle-settings">
			<div className="title-and-description-container">
				<div className="title">{title}</div>
				<div className="description">{description}</div>
			</div>
			<ToggleSwitch onChange={onChange} alignRight id={checkboxId} name={name} {...inputProps} />
		</div>
	)
}
